import { motion } from "framer-motion";

/** Scroll-based reveal: fades + rises in once when the element enters the viewport. */
export default function Reveal({
  children,
  delay = 0,
  y = 24,
  duration = 0.9,
  as = "div",
  className = "",
  ...rest
}) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </Comp>
  );
}
